module.exports = __webpack_public_path__ + "static/img/title-pt.2e2d10e2.png";